import { render, staticRenderFns } from "./PagarReciboDialog.vue?vue&type=template&id=0c55e7a6&"
import script from "./PagarReciboDialog.vue?vue&type=script&lang=js&"
export * from "./PagarReciboDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports